import { DataFarmType } from '../dataFarmType';
import { DataTransform } from '../dataTransform';
import { SortInfo } from '../sortInfo';
import { TransformRule } from '../transformRule';
import { TransformType } from '../transformType';
import { group } from '@angular/animations';

export class RowFillerTransform extends DataTransform<RowFillerTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.rowFiller,nodeID);
      this.transformConfig = new RowFillerTransformConfig();
    }

    static fromJSON(data: any): RowFillerTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: RowFillerTransform = Object.assign(new RowFillerTransform(0, 0, '', ''), data);
        instance.transformConfig = RowFillerTransformConfig.fromJSON(instance.transformConfig);

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class RowFillerTransformConfig {
    transformConfigId?: number;
    instance: string;
    farmType: DataFarmType;
    transformType: TransformType;
    groupBy: string;
    defCurrentRow: string;
    sortInfo?: SortInfo[];
    includeInResults?:string[];
    userField: string;
    timestampField: string;
    sampleStart: number;
    sampleEnd: number;
    separateBy: string;
    defTimeout: number;
    runAll:boolean;
    missesNamed: string;
    bufferRows: number
    threads: number;
    transRows: number
    addFields: any[];
    rowMissesOption:RowMissesOption;
    
    rules: RowFillerTransformRule[];

    static fromJSON(data: any): RowFillerTransformConfig {
        const instance: RowFillerTransformConfig = Object.assign(new RowFillerTransformConfig(), data);

        const rules: RowFillerTransformRule[] = [];
        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = RowFillerTransformRule.fromJSON(r);
                rules.push(rule);
            });
        }

        instance.rules = rules;
        return instance;
    }
}

export class RowFillerTransformRule extends TransformRule {
    fillType: GroupFillType;
    qualifier1: Qualifier;
    qualifier1Value: string;
    qualifier2: Qualifier2;
    qualifier2Value: number;
    currentRowField: string;
    currentRowQualifier: Qualifier;
    currentRowValue: string;
    timeout: number;

    static fromJSON(data: any): RowFillerTransformRule {
        const instance: RowFillerTransformRule = Object.assign(new RowFillerTransformRule(), data);

        return instance;
    }
}

export enum GroupFillType {
    betweenSameValues = 0,
    beforeValue = 1,
    afterValue = 2
}

export class GroupFillTypeUtil {
    static toString(val: GroupFillType): string {
        switch (val) {
            case GroupFillType.betweenSameValues:
                return 'Between same';
            case GroupFillType.beforeValue:
                return 'Before value';
            case GroupFillType.afterValue:
                return 'After value';
        }
    }
}

export enum Qualifier {
    any = 0,
    none = 1,
    equals = 2,
    contains = 3,
    notContains = 4,
    startsWith = 5,
    endswith = 6,
    onlyNumbers = 7,
    containsNumbers = 8
}

export class QualifierUtil {
    static toString(val: Qualifier): string {
        switch (val) {
            case Qualifier.any:
                return 'And only';
            case Qualifier.none:
                return 'None';
            case Qualifier.equals:
                return 'Equals';
            case Qualifier.contains:
                return 'Contains';
            case Qualifier.notContains:
                return 'Not Contains';
            case Qualifier.startsWith:
                return 'Starts with';
            case Qualifier.endswith:
                return 'Ends with';
            case Qualifier.onlyNumbers:
                return 'Only numbers';
            case Qualifier.containsNumbers:
                return 'Contains numbers';
        }
    }
}

export class CurrentRowQualifierUtil {
    static toString(val: Qualifier): string {
        switch (val) {
            case Qualifier.any:
                return 'Any';
            case Qualifier.none:
                return 'Empty';
            case Qualifier.equals:
                return 'Equals';
            case Qualifier.contains:
                return 'Contains';
            case Qualifier.notContains:
                return 'Not Contains';
            case Qualifier.startsWith:
                return 'Starts with';
            case Qualifier.endswith:
                return 'Ends with';
            case Qualifier.onlyNumbers:
                return 'Only numbers';
            case Qualifier.containsNumbers:
                return 'Contains numbers';
        }
    }
}

export enum Qualifier2 {
    noQualifier = 0,
    length = 1,
    lenLessThanOrEquals = 2,
    lenGreaterThanOrEquals = 3,
    numbersCountEquals = 4,
    numbersCountLessThanOrEquals = 5,
    numbersCountGreaterThanOrQuals = 6,
    groupByJumps=7
}

export class Qualifier2Util {
    static toString(val: Qualifier2): string {
        switch (val) {
            case Qualifier2.noQualifier:
                return 'No Qualifier';
            case Qualifier2.length:
                return 'Length =';
            case Qualifier2.lenLessThanOrEquals:
                return 'Length <=';
            case Qualifier2.lenGreaterThanOrEquals:
                return 'Length >=';
            case Qualifier2.numbersCountEquals:
                return 'Number Count =';
            case Qualifier2.numbersCountLessThanOrEquals:
                return 'Number Count <=';
            case Qualifier2.numbersCountGreaterThanOrQuals:
                return 'Number Count >=';
            case Qualifier2.groupByJumps:
                return 'Group By Jumps';
        }
    }
}

export enum RowMissesOption {
    noChange = 0,
    delete = 1,
    empty = 2,
    named = 3
}

export class RowMissesOptionUtil {
    static toString(val: RowMissesOption): string {
        switch (val) {
            case RowMissesOption.noChange:
                return 'No Change';
            case RowMissesOption.delete:
                return 'Delete Rows';
            case RowMissesOption.empty:
                return 'Empty';
            case RowMissesOption.named:
                return 'Named';
        }
    }
}

